import { useForm } from "react-hook-form";
import { Generico } from "../../components/Generico";
import { Criterio } from "../../models/riesgo/Criterio";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { useEffect, useState } from "react";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";

export const Criterios = ({ permss, toast, generic, riesgo, tipo, seleccion, seleccionar, listar, padreId, funcionalidades }) => {
    const omodel = new Criterio();
    const matrizSrv = new MonitoreoService();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model, null);
    const [registros, setRegistros] = useState(null);
    const [item, setItem] = useState(null);
    const [load, setLoad] = useState(false);
    const [dialogCriterio, setDialogCriterio] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { table, setLoading, setTotalRecords, lazyParams, inArea } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const funcionalidadPorTipo = {
        MTR_RIESGO_ACTIVIDAD: 'MATRIZ-RIESGOS-CRUD-ACTIVIDAD',
        MTR_RIESGO_AREA: 'MATRIZ-RIESGOS-CRUD-AREA',
        MTR_RIESGO_MACRO_TIPO: 'MATRIZ-RIESGOS-CRUD-MACRO-TIPO',
        MTR_RIESGO_MACRO_CAT: 'MATRIZ-RIESGOS-CRUD-MACRO-CATEGORIA',
        MTR_RIESGO_PROCESO: 'MATRIZ-RIESGOS-CRUD-PROCESO',
        MTR_RIESGO_SUBPROCESO: 'MATRIZ-RIESGOS-CRUD-SUBPROCESO',
        MTR_RIESGO_FUENTE_RIESGO: 'MATRIZ-RIESGOS-CRUD-FUENTE-RIESGO',
        MTR_RIESGO_RIESGO: 'MATRIZ-RIESGOS-CRUD-RIESGO',
        MTR_RIESGO_CAUSA_RIESGO: 'MATRIZ-RIESGOS-CRUD-CAUSA-RIESGO',
        MTR_RIESGO_TRATAMIENTO: 'MATRIZ-RIESGOS-CRUD-TRATAMIENTO',
        MTR_RIESGO_CTRL_IMPLEMENTADO: 'MATRIZ-RIESGOS-CRUD-CTRL-IMPLEMENTADO',
        MTR_RIESGO_CONTROL_AYUDA: 'MATRIZ-RIESGOS-CRUD-CONTROL-AYUDA', // No editable de momento
        MTR_RIESGO_ACTOR_INTERNO: 'MATRIZ-RIESGOS-CRUD-ACTOR-INTERNO',
        MTR_RIESGO_ACTOR_EXTERNO: 'MATRIZ-RIESGOS-CRUD-ACTOR-EXTERNO',
        MTR_RIESGO_MONITOREO_REVISION: 'MATRIZ-RIESGOS-CRUD-MONITOREO-REVISION',
        MTR_RIESGO_MENSAJE: 'MATRIZ-RIESGOS-CRUD-MENSAJE',
        MTR_RIESGO_CANAL: 'MATRIZ-RIESGOS-CRUD-CANAL',
        MTR_RIESGO_CUANDO: 'MATRIZ-RIESGOS-CRUD-CUANDO',
    };

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.tipo = tipo;
        _lazyParams.listar = listar;
        _lazyParams.matrizId = riesgo?.id;
        if (padreId) {
            _lazyParams.padreId = padreId;
        }
        matrizSrv.listado('matriz-riesgo-criterio/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogCriterio(true);
    }

    const onSubmit = (data) => {
        data.tipo = tipo;
        data.listar = listar;
        data.matrizId = riesgo?.id;
        if (padreId) {
            data.padreId = padreId;
        }
        setLoad(true);
        if (getValues('id') == null) {
            matrizSrv.nuevo(data, 'matriz-riesgo-criterio/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogCriterio(false);
                loadLazyData();
                if (['sin', 'solo', 'ambos'].includes(listar)) {
                    seleccion(null, res.data);
                }
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        } else {
            matrizSrv.editar(data, 'matriz-riesgo-criterio/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogCriterio(false);
                loadLazyData();
                if (['sin', 'solo', 'ambos'].includes(listar)) {
                    seleccion(null, res.data);
                }
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
    }

    const editar = () => {
        matrizSrv.consultar(item?.id + "/" + tipo, 'matriz-riesgo-criterio/consulta').then(res => {
            const registro = generic.renewValues(res.data, omodel.model);
            reset(registro);
            setDialogCriterio(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            group: 'eliminar-riesgo',
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    }

    const eliminar = () => {
        matrizSrv.eliminar(`${item?.id}/${tipo}?listar=${listar}&matrizId=${riesgo.id}`, 'matriz-riesgo-criterio/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
            if (['sin', 'solo', 'ambos'].includes(listar)) {
                seleccion(null, res.data);
            }
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    }

    const itemsMenu = () => {
        const items = [];
        const funcionalidadRequerida = funcionalidadPorTipo[tipo];
        const tiposNoEditables = (tipo === 'MTR_RIESGO_CONTROL_AYUDA');
        if (permss?.actualizar && siOpcion(funcionalidadRequerida))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() }, disabled: tiposNoEditables });
        if (permss?.consultar && seleccionar)
            items.push({ label: 'Seleccionar', icon: 'pi pi-check-circle', command: () => { seleccion({ cat_id: item?.id, nombre: item?.nombre }) } });
        if (permss?.eliminar && siOpcion(funcionalidadRequerida))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() }, disabled: tiposNoEditables });

        return [{ label: 'Opciones', items: items }];
    }

    const customDialogHeader = () => {
        return (
            <div>
                <i className="pi pi-user-edit icon-header" />
                <span className="title-header">
                    {getValues('id') == null ? " Nuevo " : " Editar "}
                </span>
            </div>
        );
    }

    const headerTemplate = (options) => {
        const funcionalidadRequerida = funcionalidadPorTipo[tipo];
        if (!siOpcion(funcionalidadRequerida) || tipo === 'MTR_RIESGO_CONTROL_AYUDA') return null;
        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    {permss?.crear && <Button icon="pi pi-plus" className="p-button-rounded p-button-success mr-2" type="button" tooltip="Nuevo" onClick={openNew} />}
                </div>
            </div>
        );
    }

    return (
        <>
            <Panel headerTemplate={headerTemplate}>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Panel>

            <Dialog visible={dialogCriterio} header={customDialogHeader} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogCriterio(false);
            }}
                style={{ width: '400px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inArea('nombre', 5, 30, 12)}
                    </div>
                    {generic.buttonsForms(setDialogCriterio, load)}
                </form>
            </Dialog>
        </>
    )
}
